var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatementScaleOrder = function SvgStatementScaleOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191 104"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58072",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58065",
    transform: "translate(-241 -1983)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 25,
    fill: "#fcad31",
    "data-name": "Rectangle 33326",
    rx: 5,
    transform: "translate(241 1983)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M251 1990h10v11h-10z",
    "data-name": "Rectangle 33327"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58066",
    transform: "translate(-241 -1943)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 25,
    fill: "#fcad31",
    "data-name": "Rectangle 33326",
    rx: 5,
    transform: "translate(241 1983)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M251 1990h10v11h-10z",
    "data-name": "Rectangle 33327"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58067",
    transform: "translate(-241 -1904)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 25,
    fill: "#fcad31",
    "data-name": "Rectangle 33326",
    rx: 5,
    transform: "translate(241 1983)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M251 1990h10v11h-10z",
    "data-name": "Rectangle 33327"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58068",
    transform: "translate(-139 -1983)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 25,
    fill: "#acacac",
    "data-name": "Rectangle 33326",
    rx: 5,
    transform: "translate(241 1983)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M251 1990h10v11h-10z",
    "data-name": "Rectangle 33327"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58069",
    transform: "translate(-139 -1943)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 25,
    fill: "#acacac",
    "data-name": "Rectangle 33326",
    rx: 5,
    transform: "translate(241 1983)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M251 1990h10v11h-10z",
    "data-name": "Rectangle 33327"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58070",
    transform: "translate(-139 -1904)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 25,
    fill: "#acacac",
    "data-name": "Rectangle 33326",
    rx: 5,
    transform: "translate(241 1983)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M251 1990h10v11h-10z",
    "data-name": "Rectangle 33327"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58071"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m46.335 46.555 23.674-24.556V32.69h60.231V21.999l26.789 24.556-26.789 28.968v-10.8H70.009v10.8Z",
    "data-name": "Path 51084"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 20,
    fontWeight: 600,
    transform: "translate(70 56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 20,
    fontWeight: 600,
    transform: "translate(131 56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5,
    y: 0
  }, "Z"))))));
};
export default SvgStatementScaleOrder;